{
  "CA": "Canadá",
  "US": "Estados Unidos",
  "CA_AB": "Alberta",
  "CA_BC": "Columbia Británica",
  "CA_MB": "Manitoba",
  "CA_NB": "Nuevo Brunswick",
  "CA_NL": "Terranova y Labrador",
  "CA_NS": "Nueva Escocia",
  "CA_NT": "Territorios del Noroeste",
  "CA_NU": "Nunavut",
  "CA_ON": "Ontario",
  "CA_PE": "Isla del Príncipe Eduardo",
  "CA_QC": "Quebec",
  "CA_SK": "Saskatchewan",
  "CA_YT": "Yukon",
  "US_AK": "Alaska",
  "US_AL": "Alabama",
  "US_AR": "Arkansas",
  "US_AS": "Samoa Americana",
  "US_AZ": "Arizona",
  "US_CA": "California",
  "US_CO": "Colorado",
  "US_CT": "Connecticut",
  "US_DC": "Distrito de Columbia",
  "US_DE": "Delaware",
  "US_FL": "Florida",
  "US_GA": "Georgia",
  "US_GU": "Guam",
  "US_HI": "Hawái",
  "US_IA": "Iowa",
  "US_ID": "Idaho",
  "US_IL": "Illinois",
  "US_IN": "Indiana",
  "US_KS": "Kansas",
  "US_KY": "Kentucky",
  "US_LA": "Louisiana",
  "US_MA": "Massachusetts",
  "US_MD": "Maryland",
  "US_ME": "Maine",
  "US_MI": "Michigan",
  "US_MN": "Minnesota",
  "US_MO": "Missouri",
  "US_MP": "Islas Marianas del Norte",
  "US_MS": "Mississippi",
  "US_MT": "Montana",
  "US_NC": "Carolina del Norte",
  "US_ND": "Dakota del Norte",
  "US_NE": "Nebraska",
  "US_NH": "Nuevo Hampshire",
  "US_NJ": "Nueva Jersey",
  "US_NM": "Nuevo México",
  "US_NV": "Nevada",
  "US_NY": "Nueva York",
  "US_OH": "Ohio",
  "US_OK": "Oklahoma",
  "US_OR": "Oregon",
  "US_PA": "Pensilvania",
  "US_PR": "Puerto Rico",
  "US_RI": "Isla de Rhode",
  "US_SC": "Carolina del Sur",
  "US_SD": "Dakota del Sur",
  "US_TN": "Tennessee",
  "US_TX": "Texas",
  "US_UM": "Islas menores alejadas de los Estados Unidos",
  "US_UT": "Utah",
  "US_VA": "Virginia",
  "US_VI": "Islas Vírgenes",
  "US_VT": "Vermont",
  "US_WA": "Washington",
  "US_WI": "Wisconsin",
  "US_WV": "Virginia Occidental",
  "US_WY": "Wyoming",
  "GB_ENG": "Inglaterra",
  "GB_NIR": "Irlanda del Norte",
  "GB_SCT": "Escocia"
}
